import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { localeData } from '../../../locales/data';
import { StateType } from '../../../reducers';
import { addModifiers } from '../../../shared/helpers';

import './EditField.scss';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';

interface EditFieldConnectProps {
  label: string;
  pathValue: string[];
  btnLabel: string;
  url: string;
  lockedIcon: boolean;
  typePassword: boolean;
  showButton?: boolean;
}

interface EditFieldConnectStateProps {
  value: string;
}

export const PasswordBullets = ({ num = 10 }: { num?: number }) => (
  <React.Fragment>
    {Array.apply(0, Array(num)).map((_: any, i: number) => (
      <span className="edit-field__bullets" key={`edit-field__bullets-${i}`} />
    ))}
  </React.Fragment>
);

export const EditFieldConnect = ({
  label,
  lockedIcon = true,
  value,
  typePassword = false,
  btnLabel,
  showButton = true,
  url,
}: EditFieldConnectProps & EditFieldConnectStateProps & InjectedIntlProps) => (
  <div className="edit-field">
    <label className={addModifiers('form__label', lockedIcon ? ['locked'] : [])}>
      <FormattedMessageHelper tagName="span" id={label} defaultMessage={localeData.en[label]} />
    </label>
    <div className={addModifiers('edit-field__content', typePassword ? ['password'] : [])}>
      <div className="edit-field__value">{typePassword ? <PasswordBullets /> : value}</div>
      {showButton && (
        <Link to={url} className="link link--profile">
          <FormattedMessageHelper tagName="span" id={btnLabel} defaultMessage={localeData.en[btnLabel]} />
        </Link>
      )}
    </div>
  </div>
);

const mapStateToProps = (state: StateType, ownProps: EditFieldConnectProps): EditFieldConnectStateProps => ({
  // @ts-ignore
  value: state.getIn(ownProps.pathValue),
});

export default connect<EditFieldConnectStateProps, any, any, StateType>(mapStateToProps)(injectIntl(EditFieldConnect));
